import { useCallback } from 'react'
import { Language } from '../../../pure-js/types/Antiloop'
import { useCustomerId } from '../context/CustomerContext'
import { getGrooverText } from '../libs/GrooverTextRepository'

/**
 * Context-aware text helper for user-web.
 *
 * Use this when you need a string (e.g. placeholders/labels) instead of <GrooverText />.
 * It automatically applies customer-specific overrides via the current customerId (client.id).
 */
export const useGrooverText = () => {
  const customerId = useCustomerId()

  return useCallback(
    (textKey: string, language?: Language) => {
      return getGrooverText(textKey, language, customerId ?? undefined)
    },
    [customerId]
  )
}
